import { Injectable } from '@angular/core';
import { ProductGroupReferencesFacade } from '@product/data-access';
import { ProductReference } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProductGroupReferencesService {
  constructor(private productGroupReferencesFacade: ProductGroupReferencesFacade) {}

  loadProducts(productCode: string, referenceType: string, categoryCode: string, pageSize?: number): void {
    this.productGroupReferencesFacade.loadProducts(productCode, referenceType, categoryCode, pageSize);
  }

  getProducts(productCode: string, referenceType: string, categoryCode: string): Observable<ProductReference[]> {
    return this.productGroupReferencesFacade.getProducts(productCode, referenceType, categoryCode);
  }

  getProductsLoading(productCode: string, referenceType: string, categoryCode: string): Observable<boolean> {
    return this.productGroupReferencesFacade.getProductsLoading(productCode, referenceType, categoryCode);
  }

  getProductsSuccess(productCode: string, referenceType: string, categoryCode: string): Observable<boolean> {
    return this.productGroupReferencesFacade.getProductsSuccess(productCode, referenceType, categoryCode);
  }

  getProductsError(productCode: string, referenceType: string, categoryCode: string): Observable<boolean> {
    return this.productGroupReferencesFacade.getProductsError(productCode, referenceType, categoryCode);
  }

  resetProducts(): void {
    this.productGroupReferencesFacade.resetProducts();
  }
}
